import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getPromocodesValidate } from "api/thunk/promoCodes/getActions/getPromocodesValidate";

const promocodesSlice = createSlice({
  name: "promocodes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //get_promocodes_validate
      .addCase(getPromocodesValidate.pending, (state) => {
        state.promocodesValidate.loading = true;
        state.promocodesValidate.error = null;
      })
      .addCase(getPromocodesValidate.fulfilled, (state, action) => {
        state.promocodesValidate.loading = false;
        state.promocodesValidate.data = action.payload;
      })
      .addCase(getPromocodesValidate.rejected, (state, action) => {
        state.promocodesValidate.loading = false;
        state.promocodesValidate.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
  }
})

export default promocodesSlice.reducer;